import { render } from "./LicenseBadge.vue?vue&type=template&id=5916adae&scoped=true"
import script from "./LicenseBadge.vue?vue&type=script&lang=js"
export * from "./LicenseBadge.vue?vue&type=script&lang=js"

import "./LicenseBadge.vue?vue&type=style&index=0&id=5916adae&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5916adae"]])

export default __exports__